import validator from 'validator';

/**
 * @param {any} value the value entered into field
 * @return {string|undefined} error string
 */
export const emailValidate = (value: any): string | undefined => {
  if (!value) {
    return 'This field is required';
  } else {
    // tests basic email structure ...@...
    if (!/\S+@\S+/.test(value)) {
      return 'Please enter a valid email address e.g john.smith@mail.com';
    }
  }
};

/**
 * @param {any} value the value entered into field
 * @return {string|undefined} error string
 */
export const mobileValidate = (value: any) => {
  if (!value) {
    return 'This field is required';
  }
  if (!validator.isMobilePhone(value.replace(/\s+/g, ''))) {
    return 'Please enter a valid mobile number';
  } else if (value.length > 15 || value.length < 7) {
    return 'Please enter a valid mobile number';
  }
};

export const required = (value: any) => (value ? undefined : 'This field is required');
export const composeValidators = ([...validators]) => (value: any) =>
  validators.reduce((error, validator) => error || validator(value), undefined)


/**
 * quick function to get validator until proper library is used
 *
 * @param {any} value the value entered into field
 * @return {any} return the specific validator
 */
export const getValidator = (value: any) => {
  switch (value) {
    case 'required':
      return required;
    case 'email':
      return emailValidate;
    case 'mobile':
      return mobileValidate;
  }
}